import { useState } from 'react'
import { GalleryGrid } from '../gallery/GalleryGrid'
import type { Album } from '../../types/album'
import { Calendar, Image } from 'lucide-react'
import { VisibilityBadge } from '../common/VisibilityBadge'
import { formatDateRange } from '../../lib/dateRange'
import { formatDate } from '../../utils/formatting'

interface AlbumViewProps {
  album: Album
  albumId: string
  shareToken?: string
}

export const AlbumView = ({ album, albumId, shareToken }: AlbumViewProps) => {
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc')

  return (
    <div>
      {/* Album Info */}
      <div className="mb-8">
        <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500 mb-4">
          <span className="flex items-center gap-1">
            <Image className="w-4 h-4" />
            {album.imageCount || 0} photos
          </span>
          {album.dateRange && (
            <span className="flex items-center gap-1">
              <Calendar className="w-4 h-4" />
              {formatDateRange(album.dateRange)}
            </span>
          )}
          <span className="flex items-center gap-1">
            <Calendar className="w-4 h-4" />
            Created {formatDate(album.createdAt)}
          </span>
          <VisibilityBadge visibility={album.visibility} />
        </div>

        {album.description && (
          <p className="text-gray-600 max-w-2xl">{album.description}</p>
        )}
      </div>

      {/* Sort and Photos Grid */}
      <div className="mb-4">
        <select
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value as 'asc' | 'desc')}
          className="px-2 py-1.5 text-sm border border-gray-200 rounded-lg bg-white"
        >
          <option value="desc">Newest first</option>
          <option value="asc">Oldest first</option>
        </select>
      </div>

      <GalleryGrid albumId={albumId} sortOrder={sortOrder} groupByDate shareToken={shareToken} />
    </div>
  )
}
